/* React */
import React from "react";

/* React Redux */
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { setShowModal } from "src/redux/features/charts/modalSlice";

/* Ionic */
import { IonModal } from "@ionic/react";

/* Utils */
import { getModalComponent } from "./getModalComponent";

/* Constants */
import { ModalType } from "src/shared/constants/common/Modal";

/* Stylesheet */
import styles from "./ModalWrapper.module.scss";

const ModalWrapper: React.FC = () => {
  const dispatch = useDispatch();

  const modalState = useSelector(
    (state: RootState) => state.modal
  );

  const { modalType, showModal, className } = modalState;

  return (
    <IonModal
      className={`${styles.modal_wrapper} ${
        styles[className!]
      }`}
      isOpen={showModal}
      onDidDismiss={() => {
        dispatch(
          setShowModal({
            modalType: ModalType.DEFAULT,
            showModal: false,
            className: "dev-options",
          })
        );
      }}
    >
      {getModalComponent(modalType)}
    </IonModal>
  );
};

export default ModalWrapper;
